import { ProjectLayoutModel } from 'api/dto/ProjectLayout.dto';
import { Resource } from 'model/Resource';

export namespace ProjectLayoutState {
  export type Domain = Resource<ProjectLayoutModel>;
  export const INITIAL_DOMAIN: Domain = Resource.createPendingResource<ProjectLayoutModel>();
}
